import { SkinEvent } from 'skin/ts/Skin/events/SkinEvent';
export const doNotLogList = [
    SkinEvent.ON_CONTROLS_HIDE,
    SkinEvent.ON_CONTROLS_SHOW,
    SkinEvent.ON_MOUSE_ENTER_STAGE,
    SkinEvent.ON_MOUSE_LEAVE_STAGE,
    SkinEvent.ON_MOUSE_MOVE_STAGE,
    SkinEvent.ON_MOUSE_MOVE_WINDOW,
    SkinEvent.ON_SEEK_OUT,
    SkinEvent.ON_SEEK_OVER_MOVE,
    SkinEvent.ON_TIMETIP_HIDE,
    SkinEvent.ON_TIMETIP_SHOW
];
